import React, { useEffect, useRef, useState } from 'react'
import './portfolio-pages.styles.scss';
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component';
import InstructionModal from './instruction-modal.component';
import EvidenceCard from '../../evidence-card/evidence-card.component';
import { format, set } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import PreviousAttemptsModal from '@/components/EVAL/evaluation-inputs/previous-attempts-modal.component';
import { useNavigate } from 'react-router-dom';

const PrecheckPortfolioPage = ({ mcData, mcProgress }) => {

  const [showInstructions, setShowInstructions] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [showPreviousAttempts, setShowPreviousAttempts] = useState(false);
  const [ declinedAttempts, setDeclinedAttempts ] = useState([]);
  const [ allDetails, setAllDetails ] = useState({});
  const [formData, setFormData] = useState({});
  const [evalData, setEvalData] = useState(null);
  const dataRef = useRef({});
  const navigate = useNavigate();


  useEffect(() => {
    if (!mcData || !mcProgress) return;
    dataRef.current = mcProgress[`content_precheck`];
    setFormData(dataRef.current);
    setEvalData(mcProgress.eval_precheck);
    console.log(mcProgress);
    if (mcProgress.declinedAttempts) {
      const declined = Object.values(mcProgress.declinedAttempts)
        .filter(attempt => attempt.id === 'precheck');
        console.log(declined);
      let newArr = [];
      for (let a of declined) {
        let newAtt = {...a};
        let newAttUploads = {...a.upload};
        for (let u in a.upload) {
            if (!u) break;
            const upload = mcProgress?.uploads[newAttUploads[u]];
            newAttUploads[u] = upload;
        }
        newAtt.upload = newAttUploads;
        newArr.push(newAtt);
      }
      setDeclinedAttempts(newArr);
    }
    let detailList = {}
    for (let eo of Object.values(mcData.content)) {
        if (eo.comp) {
            for (let d of Object.values(eo.comp)) {
                detailList[d.id] = d
            }
        } else {
            detailList[eo.id] = eo
        }
    }
    setAllDetails(detailList);
    console.log(detailList);
  }, [mcData, mcProgress])

  return (
    <div className='portfolio-page-container'>
      {
        (mcData && formData && formData.exp && formData.upload)
          ?
          <div>
            <div className='title-box'>
              <div className='section-title'><b>Precheck Upload and Self-Analysis</b></div>
              {
                (!formData.status || formData.status === 'saved')
                  ?
                  <button className='g-button small-btn' onClick={() => setShowInstructions(true)}>Instructions</button>
                  :
                  <div className='g-list-item approved'>Approved!</div>
              }
            </div>


            {/* <hr /> */}
            <div className="g-space-2"></div>
            <div className='portfolio-page-content'>
              <div className='g-list-item'>
                <EvidenceCard
                  mcProgress={mcProgress}
                  title='Evidence 1 (required)'
                  id='ev1'
                  hidden={false}
                  disabled={disabled}
                  formData={dataRef.current}
                  evNumber={0}
                  // chooseEvidenceFromModal={chooseEvidenceFromModal}
                  // saveExplanation={saveExplanation} 
                  // removeEvidence={removeEvidence}
                  sectionId='precheck'
                // saveDirtyStatus={saveDirtyStatus}
                />

              </div>
              <div className="g-space-2"></div>
              <div className='g-list-item'>
                <EvidenceCard
                  mcProgress={mcProgress}
                  title='Evidence 2 (optional)'
                  id='ev2'
                  hidden={!formData.exp || !formData.exp[1]}
                  disabled={disabled}
                  formData={dataRef.current}
                  evNumber={1}
                  // chooseEvidenceFromModal={chooseEvidenceFromModal}
                  // saveExplanation={saveExplanation} 
                  // removeEvidence={removeEvidence}
                  sectionId='precheck'
                // saveDirtyStatus={saveDirtyStatus}
                />
              </div>
              <div className="g-space-2"></div>
              <div className='g-list-item'>
                <EvidenceCard
                  mcProgress={mcProgress}
                  title='Evidence 3 (optional)'
                  id='ev3'
                  hidden={!formData.exp || !formData.exp[2]}
                  disabled={disabled}
                  formData={dataRef.current}
                  evNumber={2}
                  // chooseEvidenceFromModal={chooseEvidenceFromModal}
                  // saveExplanation={saveExplanation} 
                  // removeEvidence={removeEvidence}
                  sectionId='precheck'
                // saveDirtyStatus={saveDirtyStatus}
                />
              </div>
              <div className="g-space-1"></div>
            </div>
            <div className="g-space-2"></div>
            
            
            <div className='g-list-item prev-comment-item' >
              <div className='title'>Evaluator Comments:</div>
              {
                (evalData && evalData.prev_comments) &&
                Object.values(evalData.prev_comments)
                  .sort((a, b) => a.timestamp > b.timestamp ? 1 : -1)
                  .map((e, i) => {
                    if (i+1 !== Object.values(evalData.prev_comments).length) {
                      return null;
                    }
                    return (
                      <div className="eval-comment" key={e.timestamp}>
                        <div className="g-space-0-5"></div>
                        <div className='meta'>{format(new Date(e.timestamp), 'Pp')}</div>
                        <b>{e.comment}</b>
                      </div>
                    )
                  })
              }
            </div>

            {
              (declinedAttempts.length > 0) &&  // && currentData.progress.pending
              <div>
                <div className="g-space-1"></div>
                <button 
                  className='g-button small-btn prev-att-btn' 
                  onClick={() => setShowPreviousAttempts(true)}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                  View Previous Attempts
                </button>
              </div>  
              }
          </div>
          :
          <div className='center-col'><ThreeDotsLoader /></div>
      }
      <InstructionModal 
        show={showInstructions} 
        cancel={() => setShowInstructions(false)} 
        precheck={true} />
      <PreviousAttemptsModal 
        show={showPreviousAttempts} 
        cancel={() => setShowPreviousAttempts(false)} 
        previousAttempts={declinedAttempts} 
        allDetails={allDetails}
        previousComments={evalData ? evalData.prev_comments : {}}
      />
    </div>
  )
}

export default PrecheckPortfolioPage    
